/**
 * Advanced API spec (generated from designer metadata).
 */

export type ParamType =
  | 'text'
  | 'character'
  | 'room'
  | 'roomNoSpecial'
  | 'roomCurrent'
  | 'roomNoVoid'
  | 'roomDestination'
  | 'object'
  | 'variable'
  | 'image'
  | 'action'
  | 'actionEvent'
  | 'state'
  | 'media'
  | 'mediaAudio'
  | 'mediaCompass'
  | 'characterCustomProperty'
  | 'customPropertyOp'
  | 'mediaImage'
  | 'wearableObject'
  | 'objectCustomProperty'
  | 'objectAction'
  | 'containerObject'
  | 'lockableObject'
  | 'openableObject'
  | 'lockState'
  | 'openState'
  | 'wornState'
  | 'visibilityState'
  | 'playerCustomProperty'
  | 'playerAction'
  | 'roomCustomProperty'
  | 'roomAction'
  | 'exitState'
  | 'exitDirection'
  | 'statusBarItem'
  | 'timerCustomProperty'
  | 'timer'
  | 'activeState'
  | 'entryType'
  | 'entryTypeNumeric'
  | 'objectGroup'
  | 'mediaGroup'
  | 'variableCustomProperty'
  | 'gender'


const COMMAND_LABEL_OVERRIDES: Record<string, string> = {
  CT_ACTION_ADD_CUSTOMCHOICE: 'Action: Add Custom Choice',
  CT_ACTION_CLEAR_CUSTOMCHOICE: 'Action: Clear Custom Choice',
  CT_ACTION_REMOVE_CUSTOMCHOICE: 'Action: Remove Custom Choice',
  CT_DISPLAYCHARDESC: 'Character: Display Description',
  CT_CHAR_DISPLAYPORT: 'Character: Display Portrait',
  CT_MOVECHAR: 'Character: Move to Room',
  CT_MOVECHARINVTOPLAYER: 'Character: Move Inventory to Player',
  CT_CHAR_MOVETOOBJ: 'Character: Move to Object',
  CT_CHAR_SETPORT: 'Character: Set Portrait Media',
  CT_SETCHARACTION: 'Character: Set Action to Active/Inactive',
  CT_CHAR_SET_CUSTOM_PROPERTY: 'Character: Set Custom Property',
  CT_CHAR_SET_CUSTOM_PROPERTY_JS: 'Character: Set Custom Property (JavaScript)',
  CT_SETCHARDESC: 'Character: Set Description',
  CT_CHAR_SET_GENDER: 'Character: Set Gender',
  CT_CHAR_SET_NAME: 'Character: Set Display Name',
  CT_COMMENT: 'Add Comment',
  CT_DEBUGTEXT: 'Debug Text',
  CT_JAVA_SET_RAGS: 'Set RAGS Data (JavaScript)',
  CT_DISPLAYTEXT: 'Display Text',
  CT_EXPORTVARIABLE: 'Export Variable',
  CT_IMPORTVARIABLE: 'Import Variable',
  CT_PAUSEGAME: 'Pause Game',
  CT_DISPLAYLAYEREDPICTURE: 'Media: Display Layered Picture',
  CT_DISPLAYPICTURE: 'Media: Display Multimedia',
  CT_MM_SET_BACKGROUND_MUSIC: 'Media: Set Background Music',
  CT_MM_STOP_BACKGROUND_MUSIC: 'Media: Stop Background Music',
  CT_MM_PLAY_SOUNDEFFECT: 'Media: Play Sound Effect',
  CT_MM_SET_MAIN_COMPASS: 'Media: Set Main Compass Picture',
  CT_MM_SET_UD_COMPASS: 'Media: Set Up/Down Compass Picture',
  CT_LAYEREDIMAGE_ADD: 'Image: Add Layered Image',
  CT_LAYEREDIMAGE_CLEAR: 'Image: Clear Layered Images',
  CT_LAYEREDIMAGE_REMOVE: 'Image: Remove Layered Image',
  CT_LAYEREDIMAGE_REPLACE: 'Image: Replace Layered Image',
  CT_DISPLAYITEMDESC: 'Item: Display Description',
  CT_ITEM_LAYERED_REMOVE: 'Item: Layered Remove',
  CT_ITEM_LAYERED_WEAR: 'Item: Layered Wear',
  CT_MOVEITEMTOCHAR: 'Item: Move to Character',
  CT_MOVEITEMTOINV: 'Item: Move to Inventory',
  CT_MOVEITEMTOOBJ: 'Item: Move Inside Object',
  CT_MOVEITEMTOROOM: 'Item: Move to Room',
  CT_SETOBJECTACTION: 'Item: Set Action to Active/Inactive',
  CT_ITEM_SET_CUSTOM_PROPERTY: 'Item: Set Custom Property',
  CT_ITEM_SET_CUSTOM_PROPERTY_JS: 'Item: Set Custom Property (JavaScript)',
  CT_SETITEMDESC: 'Item: Set Description',
  CT_ITEM_SET_NAME_OVERRIDE: 'Item: Set Display Name',
  CT_SETLOCKEDUNLOCKED: 'Item: Set State to Locked/Unlocked',
  CT_SETOPENCLOSED: 'Item: Set State to Open/Closed',
  CT_SETITEMTOWORN: 'Item: Set State to Worn/Removed',
  CT_ITEM_SET_VISIBILITY: 'Item: Set Visibility',
  CT_ITEMS_MOVE_CONTAINER_TO_CONTAINER: 'Items: Move All From Container to Container',
  CT_LOOP_BREAK: 'Loop: Break Out of Loop',
  CT_CANCELMOVE: 'Player: Cancel Move',
  CT_DISPLAYPLAYERDESC: 'Player: Display Description',
  CT_SETLAYEREDPLAYERPORTRAIT: 'Player: Set Layered Portraits',
  CT_MOVEINVENTORYTOCHAR: 'Player: Move Inventory to Character',
  CT_MOVEINVENTORYTOROOM: 'Player: Move Inventory to Room',
  CT_MOVEPLAYER: 'Player: Move to Room',
  CT_MOVETOCHAR: 'Player: Move to Character',
  CT_MOVETOOBJ: 'Player: Move to Object',
  CT_PLAYER_SET_CUSTOM_PROPERTY: 'Player: Set Custom Property',
  CT_PLAYER_SET_CUSTOM_PROPERTY_JS: 'Player: Set Custom Property (JavaScript)',
  CT_SETPLAYERACTION: 'Player: Set Action to Active/Inactive',
  CT_SETPLAYERDESC: 'Player: Set Description',
  CT_SETPLAYERGENDER: 'Player: Set Gender',
  CT_SETPLAYERNAME: 'Player: Set Name',
  CT_SETPLAYERPORTRAIT: 'Player: Set Portrait Media',
  CT_DISPLAYROOMDESCRIPTION: 'Room: Display Description',
  CT_DISPLAYROOMPICTURE: 'Room: Display Picture',
  CT_ROOM_MOVE_ITEMS_TO_PLAYER: 'Room: Move Items to Player',
  CT_SETROOMACTION: 'Room: Set Action to Active/Inactive',
  CT_ROOM_SET_CUSTOM_PROPERTY: 'Room: Set Custom Property',
  CT_ROOM_SET_CUSTOM_PROPERTY_JS: 'Room: Set Custom Property (JavaScript)',
  CT_SETROOMDESCRIPTION: 'Room: Set Description',
  CT_SETEXIT: 'Room: Set Exit to Active/Inactive',
  CT_SETEXITDESTINATION: 'Room: Set Exit Destination',
  CT_ROOM_SET_NAME_OVERRIDE: 'Room: Set Display Name',
  CT_SETROOMLAYEREDPIC: 'Room: Set Layered Picture',
  CT_SETROOMPIC: 'Room: Set Picture',
  CT_Status_ItemVisibleInvisible: 'Status Bar: Set Visible/Invisible',
  CT_EXECUTETIMER: 'Timer: Execute Timer',
  CT_RESETTIMER: 'Timer: Reset Timer',
  CT_TIMER_SET_CUSTOM_PROPERTY: 'Timer: Set Custom Property',
  CT_TIMER_SET_CUSTOM_PROPERTY_JS: 'Timer: Set Custom Property (JavaScript)',
  CT_SETTIMER: 'Timer: Set Timer to Active/Inactive',
  CT_DISPLAYVARIABLE: 'Variable: Display Data',
  CT_SETVARIABLE: 'Variable: Set',
  CT_ITEM_GETRANDOMGROUP: 'Variable: Set with Random Item Group Member',
  CT_MM_GETRANDOMGROUP: 'Variable: Set with Random Media',
  CT_VARIABLE_SET_JAVASCRIPT: 'Variable: Set (JavaScript)',
  CT_SETVARIABLEBYINPUT: 'Variable: Set by User Input',
  CT_SETVARIABLE_NUMERIC_BYINPUT: 'Variable: Set Numeric by User Input',
  CT_VARIABLE_SET_CUSTOM_PROPERTY: 'Variable: Set Custom Property',
  CT_VARIABLE_SET_CUSTOM_PROPERTY_JS: 'Variable: Set Custom Property (JavaScript)',
  CT_VARIABLE_SET_RANDOMLY: 'Variable: Set Numeric Randomly',
  CT_VARIABLE_SET_WITH_CHARPROPERTYVALUE: 'Variable: Set with Character Custom Property',
  CT_VARIABLE_SET_WITH_ITEMPROPERTYVALUE: 'Variable: Set with Item Custom Property',
  CT_VARIABLE_SET_WITH_PLAYERPROPERTYVALUE: 'Variable: Set with Player Custom Property',
  CT_VARIABLE_SET_WITH_ROOMPROPERTYVALUE: 'Variable: Set with Room Custom Property',
  CT_VARIABLE_SET_WITH_TIMERPROPERTYVALUE: 'Variable: Set with Timer Custom Property',
  CT_VARIABLE_SET_WITH_VARIABLE: 'Variable: Set with Variable',
  CT_VARIABLE_SET_WITH_VARIABLEPROPERTYVALUE: 'Variable: Set with Variable Custom Property',
  CT_ENDGAME: 'End Game',
}

const COMMAND_PARAM_LABELS: Record<string, string[]> = (function () {
  const labelMap: Record<string, string[]> = {
    'CT_DISPLAYTEXT': ['Text to Display', 'Variable (optional)', ''],
    'CT_DISPLAYVARIABLE': ['Variable', '', ''],
    'CT_SETVARIABLE': ['Variable to Set', 'Operation', 'Variable Data'],
    'CT_ITEM_GETRANDOMGROUP': ['Variable to Set', 'Object Group', ''],
    'CT_MM_GETRANDOMGROUP': ['Variable to Set', 'Media Group', ''],
    'CT_VARIABLE_SET_JAVASCRIPT': ['Variable to Set', 'Operation', 'JavaScript'],
    'CT_SETVARIABLEBYINPUT': ['Entry Type', 'Variable to Set', 'Entry Form Title'],
    'CT_SETVARIABLE_NUMERIC_BYINPUT': ['Entry Type', 'Variable to Set', 'Entry Form Title'],
    'CT_VARIABLE_SET_CUSTOM_PROPERTY': ['Variable Property', 'Operation', 'Property Value'],
    'CT_VARIABLE_SET_CUSTOM_PROPERTY_JS': ['Variable Property', 'Operation', 'Property Value (JavaScript)'],
    'CT_VARIABLE_SET_RANDOMLY': ['Variable to Set', '', ''],
    'CT_VARIABLE_SET_WITH_CHARPROPERTYVALUE': ['Variable to Set', 'Character Property', ''],
    'CT_VARIABLE_SET_WITH_ITEMPROPERTYVALUE': ['Variable to Set', 'Item Property', ''],
    'CT_VARIABLE_SET_WITH_PLAYERPROPERTYVALUE': ['Variable to Set', 'Player Property', ''],
    'CT_VARIABLE_SET_WITH_ROOMPROPERTYVALUE': ['Variable to Set', 'Room Property', ''],
    'CT_VARIABLE_SET_WITH_TIMERPROPERTYVALUE': ['Variable to Set', 'Timer Property', ''],
    'CT_VARIABLE_SET_WITH_VARIABLE': ['Variable to Set', 'Operation', 'Variable to Use'],
    'CT_VARIABLE_SET_WITH_VARIABLEPROPERTYVALUE': ['Variable to Set', 'Variable Property', ''],
    'CT_ACTION_ADD_CUSTOMCHOICE': ['Select Action', 'New Custom Choice', ''],
    'CT_ACTION_CLEAR_CUSTOMCHOICE': ['Select Action', '', ''],
    'CT_ACTION_REMOVE_CUSTOMCHOICE': ['Select Action', 'Custom Choice to Remove', ''],
    'CT_DISPLAYCHARDESC': ['Character', '', ''],
    'CT_CHAR_DISPLAYPORT': ['Character Picture to Display', '', ''],
    'CT_MOVECHAR': ['Character', 'Room', ''],
    'CT_MOVECHARINVTOPLAYER': ['Character', '', ''],
    'CT_CHAR_MOVETOOBJ': ['Character', 'Object', ''],
    'CT_CHAR_SETPORT': ['Character', 'Portrait Image', ''],
    'CT_SETCHARACTION': ['Character', 'Action/Event', ''],
    'CT_CHAR_SET_CUSTOM_PROPERTY': ['Character Property', 'Operation', 'Property Value'],
    'CT_CHAR_SET_CUSTOM_PROPERTY_JS': ['Character Property', 'Operation', 'Property Value (JavaScript)'],
    'CT_SETCHARDESC': ['Description', '', ''],
    'CT_CHAR_SET_NAME': ['Character', 'Display Name', ''],
    'CT_COMMENT': ['Comment', '', ''],
    'CT_DEBUGTEXT': ['Text to Display', '', ''],
      'CT_JAVA_SET_RAGS': ['JavaScript to Run', '', ''],
      'CT_LAYEREDIMAGE_ADD': ['Base Image', 'Layered Image', ''],
      'CT_LAYEREDIMAGE_CLEAR': ['Base Image', '', ''],
      'CT_LAYEREDIMAGE_REMOVE': ['Base Image', 'Layered Image', ''],
      'CT_LAYEREDIMAGE_REPLACE': ['Base Image', 'Layered Image', 'Replacement Image'],
      'CT_DISPLAYITEMDESC': ['Item', '', ''],
      'CT_ITEM_LAYERED_REMOVE': ['Item', '', ''],
      'CT_ITEM_LAYERED_WEAR': ['Item', '', ''],
      'CT_MOVEITEMTOCHAR': ['Item', 'Character', ''],
      'CT_MOVEITEMTOINV': ['Item', '', ''],
      'CT_MOVEITEMTOOBJ': ['Item', 'Container Object', ''],
      'CT_MOVEITEMTOROOM': ['Item', 'Room', ''],
      'CT_SETOBJECTACTION': ['Item', 'Action/Event', ''],
      'CT_ITEM_SET_CUSTOM_PROPERTY': ['Item Property', 'Operation', 'Property Value'],
      'CT_ITEM_SET_CUSTOM_PROPERTY_JS': ['Item Property', 'Operation', 'Property Value (JavaScript)'],
      'CT_SETITEMDESC': ['Description', '', ''],
      'CT_ITEM_SET_NAME_OVERRIDE': ['Item', 'Display Name', ''],
      'CT_SETLOCKEDUNLOCKED': ['Item', 'Locked/Unlocked', ''],
      'CT_SETOPENCLOSED': ['Item', 'Open/Closed', ''],
      'CT_SETITEMTOWORN': ['Item', 'Worn/Removed', ''],
      'CT_ITEM_SET_VISIBILITY': ['Item', 'Visible/Invisible', ''],
      'CT_ITEMS_MOVE_CONTAINER_TO_CONTAINER': ['Source Container', 'Destination Container', ''],
      'CT_LOOP_BREAK': ['', '', ''],
      'CT_CANCELMOVE': ['', '', ''],
      'CT_DISPLAYPLAYERDESC': ['', '', ''],
      'CT_SETLAYEREDPLAYERPORTRAIT': ['Layered Portrait Image', '', ''],
      'CT_MOVEINVENTORYTOCHAR': ['Character', '', ''],
      'CT_MOVEINVENTORYTOROOM': ['Room', '', ''],
      'CT_MOVEPLAYER': ['Room', '', ''],
      'CT_MOVETOCHAR': ['Character', '', ''],
      'CT_MOVETOOBJ': ['Object', '', ''],
      'CT_PLAYER_SET_CUSTOM_PROPERTY': ['Player Property', 'Operation', 'Property Value'],
      'CT_PLAYER_SET_CUSTOM_PROPERTY_JS': ['Player Property', 'Operation', 'Property Value (JavaScript)'],
      'CT_SETPLAYERACTION': ['Action/Event', '', ''],
      'CT_SETPLAYERDESC': ['Description', '', ''],
      'CT_SETPLAYERGENDER': ['Gender', '', ''],
      'CT_SETPLAYERNAME': ['Name', '', ''],
      'CT_SETPLAYERPORTRAIT': ['Portrait Image', '', ''],
      'CT_DISPLAYROOMDESCRIPTION': ['Room', '', ''],
      'CT_DISPLAYROOMPICTURE': ['Room', '', ''],
      'CT_ROOM_MOVE_ITEMS_TO_PLAYER': ['Room', '', ''],
      'CT_SETROOMACTION': ['Room', 'Action/Event', ''],
      'CT_ROOM_SET_CUSTOM_PROPERTY': ['Room Property', 'Operation', 'Property Value'],
      'CT_ROOM_SET_CUSTOM_PROPERTY_JS': ['Room Property', 'Operation', 'Property Value (JavaScript)'],
      'CT_SETROOMDESCRIPTION': ['Description', '', ''],
      'CT_SETEXIT': ['Room', 'Exit', ''],
      'CT_SETEXITDESTINATION': ['Room', 'Direction', 'Destination Room'],
      'CT_ROOM_SET_NAME_OVERRIDE': ['Room', 'Display Name', ''],
      'CT_SETROOMLAYEREDPIC': ['Room', 'Layered Picture', ''],
      'CT_SETROOMPIC': ['Room', 'Picture', ''],
      'CT_Status_ItemVisibleInvisible': ['Status Bar Item', 'Visible/Invisible', ''],
      'CT_EXECUTETIMER': ['Timer', '', ''],
      'CT_RESETTIMER': ['Timer', '', ''],
      'CT_TIMER_SET_CUSTOM_PROPERTY': ['Timer Property', 'Operation', 'Property Value'],
      'CT_TIMER_SET_CUSTOM_PROPERTY_JS': ['Timer Property', 'Operation', 'Property Value (JavaScript)'],
      'CT_SETTIMER': ['Timer', 'Active/Inactive', ''],
  }

  return labelMap
})()

export function getCommandParamSchema(commandType: string): { param1?: ParamType; param2?: ParamType; param3?: ParamType; param4?: ParamType } {
  switch (commandType) {
    case 'CT_DISPLAYVARIABLE':
      return { param2: 'variable' }
    case 'CT_SETVARIABLE':
      return { param2: 'variable', param3: 'customPropertyOp', param4: 'text' }
    case 'CT_ITEM_GETRANDOMGROUP':
      return { param2: 'variable', param3: 'objectGroup' }
    case 'CT_MM_GETRANDOMGROUP':
      return { param2: 'variable', param3: 'mediaGroup' }
    case 'CT_VARIABLE_SET_JAVASCRIPT':
      return { param2: 'variable', param3: 'customPropertyOp', param4: 'text' }
    case 'CT_SETVARIABLEBYINPUT':
      return { param2: 'entryType', param3: 'variable', param4: 'text' }
    case 'CT_SETVARIABLE_NUMERIC_BYINPUT':
      return { param2: 'entryTypeNumeric', param3: 'variable', param4: 'text' }
    case 'CT_VARIABLE_SET_CUSTOM_PROPERTY':
    case 'CT_VARIABLE_SET_CUSTOM_PROPERTY_JS':
      return { param2: 'variableCustomProperty', param3: 'customPropertyOp', param4: 'text' }
    case 'CT_VARIABLE_SET_RANDOMLY':
      return { param2: 'variable' }
    case 'CT_VARIABLE_SET_WITH_CHARPROPERTYVALUE':
      return { param2: 'variable', param3: 'characterCustomProperty' }
    case 'CT_VARIABLE_SET_WITH_ITEMPROPERTYVALUE':
      return { param2: 'variable', param3: 'objectCustomProperty' }
    case 'CT_VARIABLE_SET_WITH_PLAYERPROPERTYVALUE':
      return { param2: 'variable', param3: 'playerCustomProperty' }
    case 'CT_VARIABLE_SET_WITH_ROOMPROPERTYVALUE':
      return { param2: 'variable', param3: 'roomCustomProperty' }
    case 'CT_VARIABLE_SET_WITH_TIMERPROPERTYVALUE':
      return { param2: 'variable', param3: 'timerCustomProperty' }
    case 'CT_VARIABLE_SET_WITH_VARIABLE':
      return { param2: 'variable', param3: 'customPropertyOp', param4: 'variable' }
    case 'CT_VARIABLE_SET_WITH_VARIABLEPROPERTYVALUE':
      return { param2: 'variable', param3: 'variableCustomProperty' }
    case 'CT_ACTION_ADD_CUSTOMCHOICE':
    case 'CT_ACTION_CLEAR_CUSTOMCHOICE':
    case 'CT_ACTION_REMOVE_CUSTOMCHOICE':
      return { param2: 'action' }
    case 'CT_DISPLAYCHARDESC':
    case 'CT_CHAR_DISPLAYPORT':
    case 'CT_MOVECHARINVTOPLAYER':
      return { param2: 'character' }
    case 'CT_MOVECHAR':
      return { param2: 'character', param3: 'room' }
    case 'CT_CHAR_MOVETOOBJ':
      return { param2: 'character', param3: 'object' }
    case 'CT_CHAR_SETPORT':
      return { param2: 'character', param3: 'image' }
    case 'CT_SETCHARACTION':
      return { param2: 'character', param3: 'actionEvent' }
    case 'CT_CHAR_SET_CUSTOM_PROPERTY':
    case 'CT_CHAR_SET_CUSTOM_PROPERTY_JS':
      return { param2: 'characterCustomProperty', param3: 'customPropertyOp', param4: 'text' }
    case 'CT_SETCHARDESC':
      return { param2: 'character' }
    case 'CT_CHAR_SET_GENDER':
      return { param2: 'character' }
    case 'CT_CHAR_SET_NAME':
      return { param2: 'character', param4: 'text' }
    case 'CT_LAYEREDIMAGE_ADD':
      return { param2: 'mediaImage', param3: 'mediaImage' }
    case 'CT_LAYEREDIMAGE_CLEAR':
      return { param2: 'mediaImage' }
    case 'CT_LAYEREDIMAGE_REMOVE':
      return { param2: 'mediaImage', param3: 'mediaImage' }
    case 'CT_LAYEREDIMAGE_REPLACE':
      return { param2: 'mediaImage', param3: 'mediaImage', param4: 'mediaImage' }
    case 'CT_DISPLAYITEMDESC':
      return { param2: 'object' }
    case 'CT_ITEM_LAYERED_REMOVE':
    case 'CT_ITEM_LAYERED_WEAR':
      return { param2: 'wearableObject' }
    case 'CT_MOVEITEMTOCHAR':
      return { param2: 'object', param3: 'character' }
    case 'CT_MOVEITEMTOINV':
      return { param2: 'object' }
    case 'CT_MOVEITEMTOOBJ':
      return { param2: 'object', param3: 'containerObject' }
    case 'CT_MOVEITEMTOROOM':
      return { param2: 'object', param3: 'room' }
    case 'CT_SETOBJECTACTION':
      return { param2: 'object', param3: 'objectAction' }
    case 'CT_ITEM_SET_CUSTOM_PROPERTY':
    case 'CT_ITEM_SET_CUSTOM_PROPERTY_JS':
      return { param2: 'objectCustomProperty', param3: 'customPropertyOp', param4: 'text' }
    case 'CT_SETITEMDESC':
      return { param2: 'object' }
    case 'CT_ITEM_SET_NAME_OVERRIDE':
      return { param2: 'object', param4: 'text' }
    case 'CT_SETLOCKEDUNLOCKED':
      return { param2: 'lockableObject' }
    case 'CT_SETOPENCLOSED':
      return { param2: 'openableObject' }
    case 'CT_SETITEMTOWORN':
      return { param2: 'wearableObject' }
    case 'CT_ITEM_SET_VISIBILITY':
      return { param2: 'object' }
    case 'CT_ITEMS_MOVE_CONTAINER_TO_CONTAINER':
      return { param2: 'containerObject', param3: 'containerObject' }
    case 'CT_DISPLAYPLAYERDESC':
      return {}
    case 'CT_SETLAYEREDPLAYERPORTRAIT':
      return { param2: 'mediaImage' }
    case 'CT_MOVEINVENTORYTOCHAR':
      return { param2: 'character' }
    case 'CT_MOVEINVENTORYTOROOM':
      return { param2: 'room' }
    case 'CT_MOVEPLAYER':
      return { param2: 'roomNoSpecial' }
    case 'CT_MOVETOCHAR':
      return { param2: 'character' }
    case 'CT_MOVETOOBJ':
      return { param2: 'object' }
    case 'CT_PLAYER_SET_CUSTOM_PROPERTY':
    case 'CT_PLAYER_SET_CUSTOM_PROPERTY_JS':
      return { param2: 'playerCustomProperty', param3: 'customPropertyOp', param4: 'text' }
    case 'CT_SETPLAYERACTION':
      return { param3: 'playerAction' }
    case 'CT_SETPLAYERDESC':
      return {}
    case 'CT_SETPLAYERGENDER':
      return { param2: 'gender' }
    case 'CT_SETPLAYERNAME':
      return { param4: 'text' }
    case 'CT_SETPLAYERPORTRAIT':
      return { param2: 'mediaImage' }
    case 'CT_DISPLAYROOMDESCRIPTION':
      return { param2: 'roomCurrent' }
    case 'CT_DISPLAYROOMPICTURE':
      return { param2: 'roomCurrent' }
    case 'CT_ROOM_MOVE_ITEMS_TO_PLAYER':
      return { param2: 'roomCurrent' }
    case 'CT_SETROOMACTION':
      return { param2: 'roomNoSpecial', param3: 'roomAction' }
    case 'CT_ROOM_SET_CUSTOM_PROPERTY':
    case 'CT_ROOM_SET_CUSTOM_PROPERTY_JS':
      return { param2: 'roomCustomProperty', param3: 'customPropertyOp', param4: 'text' }
    case 'CT_SETROOMDESCRIPTION':
      return { param2: 'roomCurrent' }
    case 'CT_SETEXIT':
      return { param2: 'roomNoSpecial', param3: 'exitState' }
    case 'CT_SETEXITDESTINATION':
      return { param2: 'roomNoSpecial', param3: 'exitDirection', param4: 'roomDestination' }
    case 'CT_ROOM_SET_NAME_OVERRIDE':
      return { param2: 'roomNoSpecial', param4: 'text' }
    case 'CT_SETROOMLAYEREDPIC':
      return { param2: 'roomCurrent', param3: 'mediaImage' }
    case 'CT_SETROOMPIC':
      return { param2: 'roomCurrent', param3: 'mediaImage' }
    case 'CT_Status_ItemVisibleInvisible':
      return { param2: 'statusBarItem', param3: 'visibilityState' }
    case 'CT_EXECUTETIMER':
      return { param2: 'timer' }
    case 'CT_RESETTIMER':
      return { param2: 'timer' }
    case 'CT_TIMER_SET_CUSTOM_PROPERTY':
    case 'CT_TIMER_SET_CUSTOM_PROPERTY_JS':
      return { param2: 'timerCustomProperty', param3: 'customPropertyOp', param4: 'text' }
    case 'CT_SETTIMER':
      return { param2: 'timer', param3: 'activeState' }
    case 'CT_MM_SET_BACKGROUND_MUSIC':
    case 'CT_MM_STOP_BACKGROUND_MUSIC':
    case 'CT_MM_PLAY_SOUNDEFFECT':
      return { param2: 'media' }
    case 'CT_MM_SET_MAIN_COMPASS':
    case 'CT_MM_SET_UD_COMPASS':
      return { param2: 'mediaImage' }
    case 'CT_DISPLAYPICTURE':
    case 'CT_DISPLAYLAYEREDPICTURE':
      return { param2: 'mediaImage' }
    default:
      return {}
  }
}


export type ApiParamSpec = {
  key: string
  label: string
  field: 'commandName' | 'param1' | 'param2' | 'param3' | 'param4' | 'param5'
  type?: string
}

export type ApiCommandSpec = {
  commandType: string
  functionName: string
  params: ApiParamSpec[]
}

const COMMAND_NAME_LABEL_INDEX: Record<string, number> = {
  CT_ACTION_ADD_CUSTOMCHOICE: 2,
  CT_ACTION_REMOVE_CUSTOMCHOICE: 2,
}

export function getCommandDisplayLabel(commandType: string): string {
  return COMMAND_LABEL_OVERRIDES[commandType] || commandType
}

export function getCommandParamLabels(commandType: string): string[] {
  return COMMAND_PARAM_LABELS[commandType] || []
}

function splitCommandLabel(label: string): { category: string; action: string } {
  const parts = label.split(':')
  if (parts.length === 1) {
    const single = parts[0] ?? ''
    return { category: 'General', action: single.trim() }
  }
  const category = parts[0] ?? ''
  return { category: category.trim(), action: parts.slice(1).join(':').trim() }
}

function toCamelCase(input: string): string {
  const cleaned = input.replace(/[^a-zA-Z0-9 ]+/g, ' ').trim().toLowerCase()
  if (!cleaned) return ''
  const words = cleaned.split(/\s+/)
  return words[0] + words.slice(1).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('')
}

export function commandLabelToFunctionName(label: string): string {
  const { category, action } = splitCommandLabel(label)
  if (!action) return toCamelCase(category)
  const actionWords = action.split(/\s+/).filter(Boolean)
  if (actionWords.length === 0) return toCamelCase(label)
  const verb = actionWords[0]
  const rest = actionWords.slice(1).join(' ')
  const categoryPart = category && category !== 'General' ? ` ${category}` : ''
  return toCamelCase(`${verb}${categoryPart} ${rest}`)
}

export function getCommandTextParamKeyForType(commandType: string): 'commandName' | 'param1' | 'param4' | null {
  if (!commandType || commandType === 'CT_PAUSEGAME') return null
  if (commandType === 'CT_SETVARIABLE' || commandType === 'CT_VARIABLE_SET_JAVASCRIPT') return 'param4'
  if (commandType === 'CT_ACTION_ADD_CUSTOMCHOICE' || commandType === 'CT_ACTION_REMOVE_CUSTOMCHOICE') return 'commandName'
  if (commandType === 'CT_DISPLAYTEXT' || commandType === 'CT_SETCHARDESC'
    || commandType === 'CT_DEBUGTEXT' || commandType === 'CT_COMMENT'
    || commandType === 'CT_JAVA_SET_RAGS' || commandType === 'CT_SETITEMDESC'
    || commandType === 'CT_SETPLAYERDESC' || commandType === 'CT_SETROOMDESCRIPTION'
    || commandType === 'CT_ENDGAME') return 'commandName'
  return 'param1'
}

function defaultLabelForType(type?: string): string {
  if (!type) return 'Value'
  switch (type) {
    case 'object':
      return 'Item'
    case 'room':
      return 'Room'
    case 'character':
      return 'Character'
    case 'timer':
      return 'Timer'
    case 'variable':
      return 'Variable'
    case 'action':
      return 'Action'
    case 'image':
    case 'mediaImage':
      return 'Image'
    case 'media':
    case 'mediaAudio':
    case 'mediaCompass':
      return 'Media'
    default:
      return 'Value'
  }
}

export function buildCommandParamSpecs(commandType: string): ApiParamSpec[] {
  const schema = getCommandParamSchema(commandType)
  const slots: Array<{ field: ApiParamSpec['field']; type?: string }> = []
  if (schema.param1) slots.push({ field: 'param1', type: schema.param1 })
  if (schema.param2) slots.push({ field: 'param2', type: schema.param2 })
  if (schema.param3) slots.push({ field: 'param3', type: schema.param3 })
  if (schema.param4) slots.push({ field: 'param4', type: schema.param4 })
  if (slots.length === 0) {
    slots.push({ field: 'param1' }, { field: 'param2' }, { field: 'param3' }, { field: 'param4' })
  }

  const labels = [1, 2, 3, 4].map(index => (getCommandParamLabels(commandType)[index - 1] || ''))
  const hasSchema = Object.keys(schema).length > 0
  const hasLabels = labels.some(label => label)
  const params: ApiParamSpec[] = []
  const nameIndex = COMMAND_NAME_LABEL_INDEX[commandType]
    || (getCommandTextParamKeyForType(commandType) === 'commandName' ? 1 : 0)
  if (!hasSchema && !hasLabels) {
    if (nameIndex) {
      return [{
        key: 'text',
        label: 'Text',
        field: 'commandName',
      }]
    }
    return []
  }
  let slotIndex = 0
  for (let i = 0; i < labels.length; i += 1) {
    const labelIndex = i + 1
    if (nameIndex === labelIndex) {
      const label = labels[i] || 'Text'
      params.push({
        key: toCamelCase(label) || 'text',
        label: label || 'Text',
        field: 'commandName',
      })
      continue
    }
    const slot = slots[slotIndex]
    if (!slot) continue
    slotIndex += 1
    const label = labels[i] || defaultLabelForType(slot.type)
    params.push({
      key: toCamelCase(label) || `param${labelIndex}`,
      label,
      field: slot.field,
      type: slot.type,
    })
  }
  return params
}

export function buildCommandSpec(commandType: string): ApiCommandSpec {
  const label = getCommandDisplayLabel(commandType)
  return {
    commandType,
    functionName: commandLabelToFunctionName(label),
    params: buildCommandParamSpecs(commandType),
  }
}

export function buildCommandSpecs(): ApiCommandSpec[] {
  return Object.keys(COMMAND_LABEL_OVERRIDES)
    .filter(type => type && type !== 'CT_UNINITIALIZED')
    .map(buildCommandSpec)
}
